/* src/app/projects/project-talent-insights/project-talent-insights.component.scss */
.insights-container {
  padding: 16px;
}
.metrics-row {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
  margin-bottom: 20px;
}
.metric-card {
  background: #fff;
  border: 1px solid #e8ecf0;
  border-radius: 8px;
  padding: 16px;
}
.metric-card .metric-label {
  font-size: 12px;
  color: #969696;
  margin-bottom: 6px;
}
.metric-card .metric-value {
  font-size: 22px;
  font-weight: 700;
  color: #484b59;
}
.chart-section {
  background: #fff;
  border: 1px solid #e8ecf0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
}
.chart-section .chart-title {
  font-size: 14px;
  font-weight: 600;
  color: #484b59;
  margin-bottom: 12px;
}
::ng-deep .button-place .modal-content {
  position: relative;
}
::ng-deep .button-place .btn-trms-medium {
  position: absolute;
  bottom: 0;
  right: 0;
  transform: translateY(50px);
}
::ng-deep .button-place .modal-dialog,
::ng-deep .button-place .modal-content {
  overflow: visible;
}
/*# sourceMappingURL=project-talent-insights.component-QVYJP5CE.css.map */
